import React, { Component } from "react";
import {
  Box,
  Typography,
  Link,
  Button,
  Paper,
} from "@material-ui/core";
import {
  OpenInNew as OpenIcon,
  PictureAsPdf as PdfIcon,
  InsertDriveFile as FileIcon,
} from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import {
  resolveMediaUrl,
  getMediaKind,
  mediaFileName,
} from "../../utils/media";

const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  label: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  previewFrame: {
    display: "block",
    width: "100%",
    maxWidth: 520,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: "hidden",
    backgroundColor: theme.palette.grey[100],
    cursor: "pointer",
    textDecoration: "none",
    color: "inherit",
    "&:hover": {
      boxShadow: theme.shadows[2],
    },
  },
  image: {
    display: "block",
    width: "100%",
    maxHeight: 360,
    objectFit: "contain",
    backgroundColor: "#fff",
  },
  pdfEmbed: {
    display: "block",
    width: "100%",
    height: 420,
    border: 0,
    backgroundColor: "#fff",
    pointerEvents: "none",
  },
  fallback: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    minHeight: 140,
    padding: theme.spacing(2),
    textAlign: "center",
  },
  actions: {
    marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  fileName: {
    wordBreak: "break-all",
    color: theme.palette.text.secondary,
  },
});

class MediaPreview extends Component {
  open = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const href = resolveMediaUrl(this.props.url);
    if (href) window.open(href, "_blank", "noopener,noreferrer");
  };

  renderPreviewBody = (kind, href, label, name) => {
    const { classes } = this.props;
    if (kind === "image") {
      return (
        <img
          src={href}
          alt={label || name || "Attachment"}
          className={classes.image}
        />
      );
    }
    if (kind === "pdf") {
      return (
        <iframe
          title={label || name || "PDF preview"}
          src={`${href}#toolbar=0&navpanes=0`}
          className={classes.pdfEmbed}
        />
      );
    }
    return (
      <Box className={classes.fallback}>
        {kind === "pdf" ? (
          <PdfIcon fontSize="large" color="error" />
        ) : (
          <FileIcon fontSize="large" color="action" />
        )}
        <Typography variant="body2" className={classes.fileName}>
          {name || "Attachment"}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          Click to open
        </Typography>
      </Box>
    );
  };

  render() {
    const { classes, url, label } = this.props;
    const href = resolveMediaUrl(url);
    if (!href) return null;

    const kind = getMediaKind(href);
    const name = mediaFileName(href);

    return (
      <Box className={classes.root}>
        {label && (
          <Typography variant="subtitle2" className={classes.label}>
            {label}
          </Typography>
        )}
        <Paper
          className={classes.previewFrame}
          elevation={0}
          component="a"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={this.open}
          title="Open in new tab"
        >
          {this.renderPreviewBody(kind, href, label, name)}
        </Paper>
        <Box className={classes.actions}>
          <Button
            size="small"
            color="primary"
            startIcon={<OpenIcon />}
            onClick={this.open}
          >
            Open
          </Button>
          <Link
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            className={classes.fileName}
            onClick={this.open}
          >
            {name}
          </Link>
        </Box>
      </Box>
    );
  }
}

export default withStyles(styles)(MediaPreview);
